module.exports = __webpack_public_path__ + "img/DWP.fa573045.jpg";